import type { I18n } from "@lingui/core"
import { formatRelative } from "../../../../lib/format-date"
import { formatUsd } from "../../../../lib/format-money"
import type { TBalanceUnit } from "./interfaces"

/** Format a balance/threshold in its unit (USD currency, or "N credits"). */
export function formatAmount(value: number | null, unit: TBalanceUnit): string {
  if (value == null) return "—"
  // USD goes through the one deterministic money helper (was a locale-dependent
  // toLocaleString currency render). Credits are a count — 2-decimal, no
  // locale grouping, so the value is identical across runtimes.
  if (unit === "usd") return formatUsd(value)
  const rounded = Math.round(value * 100) / 100
  return `${rounded} credits`
}

/** Compact runway label, e.g. "~3.4d". null when not computable. */
export function formatDays(days: number | null): string | null {
  if (days == null) return null
  if (days >= 365) return "365d+"
  return `~${days.toFixed(days < 10 ? 1 : 0)}d`
}

/** Relative "checked N ago" — localised via the shared {@link formatRelative}. */
export function formatChecked(i18n: I18n, iso: string | null): string {
  if (!iso) return "—"
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return "—"
  return formatRelative(i18n, Date.now() - then)
}
